import { useEffect } from 'react';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useActionBar } from 'common/actionBar/hooks/useActionBar';
import { Stack, Box, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { SearchPeopleProfile } from 'modules/sourcing-external/types/SearchPeopleQueryItem';

type SourcingExternalSearchSelectionBarProps = {
  rows: SearchPeopleProfile[];
};

export const SourcingExternalSearchSelectionBar: React.FC<
  SourcingExternalSearchSelectionBarProps
> = ({ rows }) => {
  const { openActionBar, closeActionBar } = useActionBar();
  const selectedRows = useSourcingExternalStore((state) => state.selectedRows);
  const onDeselectAllRows = useSourcingExternalStore(
    (state) => state.onDeselectAllRows
  );
  const onSelectMultipleRows = useSourcingExternalStore(
    (state) => state.onSelectMultipleRows
  );
  const onInviteCandidates = useSourcingExternalStore(
    (state) => state.onInviteCandidates
  );

  const onSelectAll = () => {
    onSelectMultipleRows({
      selectedRows,
      rows
    });
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      openActionBar({
        children: (
          <Stack direction="row" gap="20px" alignItems="center">
            <Typography>{selectedRows.length} candidates selected</Typography>
            <Button
              variant="tertiary"
              onClick={() => onDeselectAllRows(selectedRows)}
            >
              Deselect all
            </Button>
            <Button variant="secondary" onClick={onSelectAll}>
              Select all
            </Button>
            <Button variant="primary" onClick={onInviteCandidates}>
              Invite
            </Button>
          </Stack>
        )
      });
    } else {
      closeActionBar();
    }
    return () => {
      closeActionBar();
    };
  }, [selectedRows]);
  // NOTE: This height prevents the action bar from cutting off content
  return <Box height={selectedRows.length > 0 ? '80px' : '0px'} />;
};
